import React, { Component } from 'react';
import logo2 from '../assets/logo2.png';

class SeminarWongwianyai1 extends Component {
  state = {
    registered: {}
  };

  componentDidMount() {
    // Load saved registration state from localStorage
    const saved = localStorage.getItem("registered_wongwianyai");
    if (saved) {
      this.setState({ registered: JSON.parse(saved) });
    }
  }

  handleRegister = (id) => {
    const isRegistered = this.state.registered[id];

    if (isRegistered) {
      // Ask to unregister
      const confirmUnregister = window.confirm("Do you want to unregister?");
      if (confirmUnregister) {
        this.setState((prevState) => {
          const updated = { ...prevState.registered };
          delete updated[id];
          localStorage.setItem("registered_wongwianyai", JSON.stringify(updated));
          return { registered: updated };
        });
      }
    } else {
      // Ask to register
      const confirmRegister = window.confirm("Do you want to register?");
      if (confirmRegister) {
        this.setState((prevState) => {
          const updated = { ...prevState.registered, [id]: true };
          localStorage.setItem("registered_wongwianyai", JSON.stringify(updated));
          return { registered: updated };
        });
      }
    }
  };

  renderParticipant = (id, name) => {
    const isRegistered = this.state.registered[id];
    return (
      <div key={id}>
        <span
          onClick={() => this.handleRegister(id)}
          style={{
            color: isRegistered ? "red" : "blue",
            cursor: "pointer"
          }}
        >
          {id}. {name}
        </span>
      </div>
    );
  };

  render() {
    return (
      <div className='RosterTuesday1'>
        <h3>Aikido Wong Wian Yai Dojo Participants Day 1</h3>
        <br /><br />

        {this.renderParticipant(1, "นายธงชัย ทิวาสิริกุล")}
        <br />
        {this.renderParticipant(2, "นายกานต์ ศรีสุวรรณ")}
        <br />
        {this.renderParticipant(3, "นายสุรเชษฐ์ ธารีพุฒ")}
        <br />
        {this.renderParticipant(4, "Mr.Ronbanchob Apiratikul")}
        <br />
        {this.renderParticipant(5, "Mr.Pongnart Sapsompong")}
        <br />

        <div>
          ASEAN AIKIDO FELLOWSHIP SEMINAR 2025 REGISTRATION SYSTEM...
        </div>
        <br /><br />
        <div>Powered by</div>
        <img className='logo2' src={logo2} alt="logo" />
        <div>New Wave Consulting Group</div>
      </div>
    );
  }
}

export default SeminarWongwianyai1;
